import { render, staticRenderFns } from "./PerformanceTargetDetails.vue?vue&type=template&id=227ff305"
import script from "./PerformanceTargetDetails.vue?vue&type=script&lang=js"
export * from "./PerformanceTargetDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports